const validate = (values: any) => {
  const errors: {
    title: string | undefined;
    assignedTo: string | undefined;
    description: string | undefined;
    predecessorTo: string | undefined;
    successorTo: string | undefined;
    dueDate: string | undefined;
  } = {
    title: undefined,
    assignedTo: undefined,
    description: undefined,
    predecessorTo: undefined,
    successorTo: undefined,
    dueDate: undefined,
  };

  if (!values.title) {
    errors.title = "Title is required";
  }
  // if (!values.dueDate) {
  //   errors.dueDate = "Required";
  // }

  return errors;
};

export default validate;
